import { TimeZoneOption } from '@/types'

export const timeZoneList: TimeZoneOption[] = [
  // {
  //   value: 'DST',
  //   abbr: 'DST',
  //   label: '(GMT-12:00) International Date Line West',
  // },
  {
    value: 'Pacific/Midway',
    abbr: 'U',
    label: '(GMT-11:00) Coordinated Universal Time-11',
  },
  {
    value: 'Pacific/Honolulu',
    abbr: 'HST',
    label: '(GMT-10:00) Hawaii',
  },
  {
    value: 'America/Anchorage',
    abbr: 'AKDT',
    label: '(GMT-09:00) Alaskan Standard Time',
  },
  {
    value: 'America/Los_Angeles',
    abbr: 'PST',
    label: '(GMT-08:00) Pacific Standard Time (US & Canada)',
  },
  {
    value: 'America/Creston',
    abbr: 'UMST',
    label: '(GMT-07:00) Arizona',
  },
  {
    value: 'America/Belize',
    abbr: 'CAST',
    label: '(GMT-06:00) Central America',
  },
  {
    value: 'America/Regina',
    abbr: 'CCST',
    label: '(GMT-06:00) Saskatchewan',
  },
  {
    value: 'America/Bogota',
    abbr: 'SPST',
    label: '(GMT-05:00) Bogota, Lima, Quito',
  },
  {
    value: 'America/Detroit',
    abbr: 'EST',
    label: '(GMT-05:00) Central Standard Time (US & Canada)',
  },
  {
    value: 'America/Indiana/Marengo',
    abbr: 'UEDT',
    label: '(GMT-05:00) Indiana (East)',
  },
  {
    value: 'America/Caracas',
    abbr: 'VST',
    label: '(GMT-04:30) Caracas',
  },
  {
    value: 'America/Asuncion',
    abbr: 'PYT',
    label: '(GMT-04:00) Asuncion',
  },
  {
    value: 'America/Campo_Grande',
    abbr: 'CBST',
    label: '(GMT-04:00) Cuiaba',
  },
  {
    value: 'America/Anguilla',
    abbr: 'SWST',
    label: '(GMT-04:00) Georgetown, La Paz, Manaus, San Juan',
  },
  {
    value: 'America/Santiago',
    abbr: 'PSST',
    label: '(GMT-04:00) Santiago',
  },
  {
    value: 'America/Sao_Paulo',
    abbr: 'ESAST',
    label: '(GMT-03:00) Brasilia',
  },
  {
    value: 'America/Argentina/La_Rioja',
    abbr: 'AST',
    label: '(GMT-03:00) Buenos Aires',
  },
  {
    value: 'America/Araguaina',
    abbr: 'SEST',
    label: '(GMT-03:00) Cayenne, Fortaleza',
  },
  {
    value: 'America/Montevideo',
    abbr: 'MST',
    label: '(GMT-03:00) Montevideo',
  },
  {
    value: 'America/Bahia',
    abbr: 'BST',
    label: '(GMT-03:00) Salvador',
  },
  {
    value: 'America/Noronha',
    abbr: 'U',
    label: '(GMT-02:00) Coordinated Universal Time-02',
  },
  {
    value: 'Atlantic/Cape_Verde',
    abbr: 'CVST',
    label: '(GMT-01:00) Cape Verde Is.',
  },
  {
    value: 'America/Danmarkshavn',
    abbr: 'GMT',
    label: '(GMT) Coordinated Universal Time',
  },
  {
    value: 'Europe/Isle_of_Man',
    abbr: 'GMT',
    label: '(GMT) Edinburgh, London',
  },
  {
    value: 'Africa/Abidjan',
    abbr: 'GST',
    label: '(GMT) Monrovia, Reykjavik',
  },
  {
    value: 'Africa/Algiers',
    abbr: 'WCAST',
    label: '(GMT+01:00) West Central Africa',
  },
  {
    value: 'Africa/Windhoek',
    abbr: 'NST',
    label: '(GMT+01:00) Windhoek',
  },
  {
    value: 'Africa/Cairo',
    abbr: 'EST',
    label: '(GMT+02:00) Cairo',
  },
  {
    value: 'Africa/Blantyre',
    abbr: 'SAST',
    label: '(GMT+02:00) Harare, Pretoria',
  },
  {
    value: 'Europe/Istanbul',
    abbr: 'TDT',
    label: '(GMT+03:00) Istanbul',
  },
  {
    value: 'Africa/Tripoli',
    abbr: 'LST',
    label: '(GMT+02:00) Tripoli',
  },
  {
    value: 'Asia/Amman',
    abbr: 'JST',
    label: '(GMT+03:00) Amman',
  },
  {
    value: 'Asia/Baghdad',
    abbr: 'AST',
    label: '(GMT+03:00) Baghdad',
  },
  {
    value: 'Europe/Kaliningrad',
    abbr: 'KST',
    label: '(GMT+02:00) Kaliningrad',
  },
  {
    value: 'Asia/Aden',
    abbr: 'AST',
    label: '(GMT+03:00) Kuwait, Riyadh',
  },
  {
    value: 'Africa/Addis_Ababa',
    abbr: 'EAST',
    label: '(GMT+03:00) Nairobi',
  },
  {
    value: 'Europe/Kirov',
    abbr: 'MSK',
    label: '(GMT+03:00) Moscow, St.Petersburg, Volgograd, Minsk',
  },
  {
    value: 'Europe/Astrakhan',
    abbr: 'SAMT',
    label: '(GMT+04:00) Samara, Ulyanovsk, Saratov',
  },
  {
    value: 'Asia/Dubai',
    abbr: 'AST',
    label: '(GMT+04:00) Abu Dhabi, Muscat',
  },
  {
    value: 'Indian/Mahe',
    abbr: 'MST',
    label: '(GMT+04:00) Port Louis',
  },
  {
    value: 'Asia/Tbilisi',
    abbr: 'GET',
    label: '(GMT+04:00) Tbilisi',
  },
  {
    value: 'Asia/Yerevan',
    abbr: 'CST',
    label: '(GMT+04:00) Yerevan',
  },
  {
    value: 'Asia/Kabul',
    abbr: 'AST',
    label: '(GMT+04:30) Kabul',
  },
  {
    value: 'Antarctica/Mawson',
    abbr: 'WAST',
    label: '(GMT+05:00) Ashgabat, Tashkent',
  },
  {
    value: 'Asia/Yekaterinburg',
    abbr: 'YEKT',
    label: '(GMT+05:00) Yekaterinburg',
  },
  {
    value: 'Asia/Karachi',
    abbr: 'PKT',
    label: '(GMT+05:00) Islamabad, Karachi',
  },
  {
    value: 'Asia/Kolkata',
    abbr: 'IST',
    label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  },
  {
    value: 'Asia/Colombo',
    abbr: 'SLST',
    label: '(GMT+05:30) Sri Jayawardenepura',
  },
  {
    value: 'Asia/Kathmandu',
    abbr: 'NST',
    label: '(GMT+05:45) Kathmandu',
  },
  {
    value: 'Antarctica/Vostok',
    abbr: 'CAST',
    label: '(GMT+06:00) Nur-Sultan (Astana)',
  },
  {
    value: 'Asia/Dhaka',
    abbr: 'BST',
    label: '(GMT+06:00) Dhaka',
  },
  {
    value: 'Asia/Rangoon',
    abbr: 'MST',
    label: '(GMT+06:30) Yangon (Rangoon)',
  },
  {
    value: 'Antarctica/Davis',
    abbr: 'SAST',
    label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
  },
  {
    value: 'Asia/Novokuznetsk',
    abbr: 'NCAST',
    label: '(GMT+07:00) Novosibirsk',
  },
  {
    value: 'Asia/Hong_Kong',
    abbr: 'CST',
    label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
  },
  {
    value: 'Asia/Krasnoyarsk',
    abbr: 'NAST',
    label: '(GMT+08:00) Krasnoyarsk',
  },
  {
    value: 'Asia/Brunei',
    abbr: 'MPST',
    label: '(GMT+08:00) Kuala Lumpur, Singapore',
  },
  {
    value: 'Antarctica/Casey',
    abbr: 'WAST',
    label: '(GMT+08:00) Perth',
  },
  {
    value: 'Asia/Taipei',
    abbr: 'TST',
    label: '(GMT+08:00) Taipei',
  },
  {
    value: 'Asia/Choibalsan',
    abbr: 'UST',
    label: '(GMT+08:00) Ulaanbaatar',
  },
  {
    value: 'Asia/Irkutsk',
    abbr: 'NAEST',
    label: '(GMT+08:00) Irkutsk',
  },
  {
    value: 'Asia/Dili',
    abbr: 'JST',
    label: '(GMT+09:00) Osaka, Sapporo, Tokyo',
  },
  {
    value: 'Asia/Pyongyang',
    abbr: 'KST',
    label: '(GMT+09:00) Seoul',
  },
  {
    value: 'Australia/Adelaide',
    abbr: 'CAST',
    label: '(GMT+09:30) Adelaide',
  },
  {
    value: 'Australia/Darwin',
    abbr: 'ACST',
    label: '(GMT+09:30) Darwin',
  },
  {
    value: 'Australia/Brisbane',
    abbr: 'EAST',
    label: '(GMT+10:00) Brisbane',
  },
  {
    value: 'Australia/Melbourne',
    abbr: 'AEST',
    label: '(GMT+10:00) Canberra, Melbourne, Sydney',
  },
  {
    value: 'Antarctica/DumontDUrville',
    abbr: 'WPST',
    label: '(GMT+10:00) Guam, Port Moresby',
  },
  {
    value: 'Australia/Currie',
    abbr: 'TST',
    label: '(GMT+10:00) Hobart',
  },
  {
    value: 'Asia/Chita',
    abbr: 'YST',
    label: '(GMT+09:00) Yakutsk',
  },
  {
    value: 'Antarctica/Macquarie',
    abbr: 'CPST',
    label: '(GMT+11:00) Solomon Is., New Caledonia',
  },
  {
    value: 'Asia/Sakhalin',
    abbr: 'VST',
    label: '(GMT+11:00) Vladivostok',
  },
  {
    value: 'Antarctica/McMurdo',
    abbr: 'NZST',
    label: '(GMT+12:00) Auckland, Wellington',
  },
  {
    value: 'Pacific/Funafuti',
    abbr: 'U',
    label: '(GMT+12:00) Coordinated Universal Time+12',
  },
  {
    value: 'Pacific/Fiji',
    abbr: 'FST',
    label: '(GMT+12:00) Fiji',
  },
  {
    value: 'Asia/Anadyr',
    abbr: 'MST',
    label: '(GMT+12:00) Magadan',
  },
  {
    value: 'Pacific/Enderbury',
    abbr: 'TST',
    label: "(GMT+13:00) Nuku'alofa",
  },
  {
    value: 'Pacific/Apia',
    abbr: 'SST',
    label: '(GMT+13:00) Samoa',
  },
]
